import ReduxSagaFirebase from 'redux-saga-firebase';
import firebase from 'firebase';
import config from '../globals/config'
const firebaseApp = firebase.initializeApp({
    apiKey: config.REACT_APP_FB_API_KEY,
    authDomain: config.REACT_APP_FB_AUTH_DOMAIN,
    databaseURL: config.REACT_APP_FB_DB_URL,
    projectId: config.REACT_APP_FB_PROJECT_ID,
    storageBucket: config.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: config.REACT_APP_MESSAGING_SENDER_ID,
});
const storage = firebaseApp.storage();
export const storageList = path =>
    storage
        .ref()
        .child(`/${path}/`)
        .listAll();
export const rsf = new ReduxSagaFirebase(firebaseApp);
